export const MENU_EXAMPLE = [
    {
        type: "list",
        vTo: "/",
        vClass: "",
        vIcon: "mdi-home",
        vTitle: "Home"
    },
    {
        type: "list",
        vTo: "/project",
        vClass: "",
        vIcon: "mdi-folder",
        vTitle: "Project"
    },
    {
        type: "list",
        vTo: "/team",
        vClass: "",
        vIcon: "person",
        vTitle: "Team"
    },
    {
        type: "group",
        prependIcon: "prepend-icon",
        vTitle: "Users",
        child: [
            {
                type: "list",
                vTo: "/",
                vClass: "",
                vIcon: "mdi-home",
                vTitle: "Home"
            }
        ]
    }
];
export const MENU_MANAGE = [
    {
        type: "list",
        vTo: "/",
        vClass: "",
        vIcon: "person",
        vTitle: "Tổng quan"
    },
    {
        type: "list",
        vTo: "/user-profile",
        vClass: "",
        vIcon: "person",
        vTitle: "Tài khoản"
    },
    {
        type: "list",
        vTo: "/team3",
        vClass: "",
        vIcon: "person",
        vTitle: "Thanh toán"
    }
];

export const MENU_SEEDING = [
    {
        type: "group",
        prependIcon: "mdi-facebook",
        vIcon: "mdi-home",
        vTitle: "Facebook Buff",
        vClass: "menu-fb-buff",
        child: [
            {
                type: "list",
                vTo: "/fb-post",
                vClass: "",
                vIcon: "mdi-comment-multiple",
                vTitle: "Buff Like, Comment, Share",
                src: "/images/landing/like-post.png",
                vToJson: { name: 'fb.post'},
            },
            {
                type: "list",
                vTo: "/fb-follow",
                vClass: "",
                vIcon: "mdi-account-multiple-plus",
                vTitle: "Buff Sub (Tăng theo dõi)",
                src: "/images/landing/follow.png",
                vToJson: { name: 'fb.follow'},
            },
            {
                type: "list",
                vTo: "/share-stream",
                vClass: "",
                vIcon: "mdi-share",
                vTitle: "Buff Share Live Stream",
            },
            {
                type: "list",
                vTo: "/post-group",
                vClass: "",
                vIcon: "mdi-share",
                vTitle: "Post/share bài vào group",
            },
            {
                type: "list",
                vTo: "/fb-fan-page",
                vClass: "",
                vIcon: "mdi-account-multiple-check",
                vTitle: "Buff Like Fanpage",
                src: "/images/landing/like-page.png",
                vToJson: { name: 'fb.fan-page'},
            },
            {
                type: "list",
                vTo: "/fb-stream",
                vClass: "",
                vIcon: "mdi-eye",
                vTitle: "Buff Mắt LiveStream",
                src: "/images/landing/eyes.png",
                vToJson: { name: 'fb.stream'},
            },
            {
                type: "list",
                vTo: "/fb-review",
                vClass: "",
                vIcon: "mdi-chart-line-variant",
                vTitle: "Buff review fanpage",
                src: "/images/landing/star.png",
                vToJson: { name: 'fb.fanpage-review'},
            },
            {
                type: "list",
                vTo: "/fb-group",
                vClass: "",
                vIcon: "mdi-account-group",
                vTitle: "Buff Member Group",
                src: "/images/landing/group.png",
                vToJson: { name: 'fb.group'},
            },
            {
                type: "list",
                vTo: "/fb-like-comment",
                vClass: "",
                vIcon: "mdi-comment-text-multiple-outline",
                vTitle: "Buff Like Comment",
                src: "/images/landing/like-comment.png",
                vToJson: { name: 'fb.like-comment'},
            },
            {
                type: "list",
                vTo: "/facebook-view",
                vClass: "",
                vIcon: "mdi-view-carousel",
                src: "/images/landing/view-v2.png",
                vTitle: "Buff View Facebook",
                vToJson: { name: 'facebook.view'},
            },
            {
                type: "list",
                vTo: "/like-sub-comment",
                vClass: "",
                vIcon: "mdi-view-carousel",
                src: "/images/landing/like-post.png",
                vTitle: "Buff Like Sub Tây",
                vToJson: { name: 'fb.like.tay'},
            },
            {
                type: "list",
                vTo: "/fb-rip-account",
                vClass: "",
                vIcon: "mdi-block-helper",
                vTitle: "Rip account",
                vToJson: { name: 'fb.rip-account'},
            },
            {
                type: "list",
                vTo: "http://m.me/103929798025757",
                vClass: "",
                outside: true,
                vIcon: "mdi-lock-open-outline",
                vTitle: "Mở nick",
                src: "/images/rip.png",
                vToJson: { name: 'fb.open-rip-nick'},
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-heart-outline",
        vIcon: "mdi-heart-outline",
        vTitle: "BOT Tương Tác",
        vClass: "",
        isHot: true,
        child: [
            {
                type: "list",
                vTo: "/buy-ip",
                vClass: "",
                vIcon: "mdi-shield-half-full",
                vTitle: "Mua Proxy riêng",
            },
            {
                type: "list",
                vTo: "/bot-add-user",
                vClass: "",
                vIcon: "mdi-plus-circle",
                vTitle: "Thêm người dùng",
            },
            {
                type: "list",
                vTo: "/bot-list-user",
                vClass: "",
                vIcon: "mdi-format-list-bulleted",
                vTitle: "Danh sách người dùng",
            },
            {
                type: "list",
                vTo: "/bot-activity-log",
                vClass: "",
                vIcon: "mdi-history",
                vTitle: "Nhật ký hoạt động",
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-facebook",
        vIcon: "mdi-home",
        vTitle: "Facebook Vip",
        vClass: "menu-fbvip-buff",
        child: [
            {
                type: "list",
                vTo: "/vip-like-clone",
                vClass: "",
                vIcon: "mdi-calendar-check-outline",
                vTitle: "Vip Like Giá Rẻ"
            },
            {
                type: "list",
                vTo: "/vip-like-month",
                vClass: "",
                vIcon: "mdi-calendar-check",
                vTitle: "Vip Like Bài Viết Tháng"
            },
            {
                type: "list",
                vTo: "/vip-like-mount",
                vClass: "",
                vIcon: "mdi-numeric",
                vTitle: "Vip Like Bài Viết Theo Số Lượng"
            },
            {
                type: "list",
                vTo: "/vip-reaction-month",
                vClass: "",
                vIcon: "mdi-calendar-today",
                vTitle: "Vip Cảm Xúc Bài Viết Tháng"
            },
            {
                type: "list",
                vTo: "/vip-comment-month",
                vClass: "",
                vIcon: "mdi-calendar-text",
                vTitle: "Vip Bình Luận Bài Viết Tháng"
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-instagram",
        vIcon: "mdi-home",
        vTitle: "Instagram Buff",
        vClass: "menu-insta-buff",
        child: [
            {
                type: "list",
                vTo: "/insta-like",
                vClass: "",
                vIcon: "mdi-heart-box",
                vTitle: "Buff Like Instagram"
            },
            {
                type: "list",
                vTo: "/insta-follow",
                vClass: "",
                vIcon: "mdi-account-multiple-plus",
                vTitle: "Buff Follow Instagram"
            },
            {
                type: "list",
                vTo: "/insta-comment",
                vClass: "",
                vIcon: "mdi-comment-multiple",
                vTitle: "Buff Comment Instagram"
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-instagram",
        vIcon: "mdi-home",
        vTitle: "Instagram Vip",
        vClass: "menu-instagram-vip-buff",
        child: [
            {
                type: "list",
                vTo: "/vip-like-instagram-month",
                vClass: "",
                vIcon: "mdi-calendar-check",
                vTitle: "Vip Like Bài Viết Tháng"
            },
            {
                type: "list",
                vTo: "/vip-comment-instagram-month",
                vClass: "",
                vIcon: "mdi-calendar-text",
                vTitle: "Vip Bình Luận Bài Viết Tháng"
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-music-circle",
        vIcon: "mdi-home",
        vTitle: "TikTok Buff",
        vClass: "menu-tiktok-buff",
        child: [
            {
                type: "list",
                vTo: "/tiktok-like",
                vClass: "",
                vIcon: "mdi-heart-circle",
                src: "/images/landing/like-post-(1).png",
                vTitle: "Buff Like(Thả tim) TikTok",
                vToJson: { name: 'tiktok.like'},
            },
            {
                type: "list",
                vTo: "/tiktok-comment",
                vClass: "",
                vIcon: "mdi-comment-multiple",
                src: "/images/landing/like-post-(1).png",
                vTitle: "Buff Comment TikTok",
                vToJson: { name: 'tiktok.comment'},
            },
            {
                type: "list",
                vTo: "/tiktok-follow",
                vClass: "",
                vIcon: "mdi-account-multiple-plus",
                src: "/images/landing/follow-(1).png",
                vTitle: "Buff Follow TikTok",
                vToJson: { name: 'tiktok.follow'},
            },
            {
                type: "list",
                vTo: "/tiktok-view",
                vClass: "",
                vIcon: "mdi-eye-outline",
                src: "/images/landing/follow-(1).png",
                vTitle: "Buff View TikTok",
                vToJson: { name: 'tiktok.view'},
            },
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-music-circle",
        vIcon: "mdi-home",
        vTitle: "TikTok Vip",
        vClass: "menu-tiktok-buff",
        child: [
            {
                type: "list",
                vTo: "/vip-like-tiktok",
                vClass: "",
                vIcon: "mdi-calendar-check-outline",
                vTitle: "Vip Like Tiktok"
            }
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-youtube",
        vIcon: "mdi-home",
        vTitle: "Youtube Buff",
        vClass: "menu-youtube-buff",
        child: [
            {
                type: "list",
                vTo: "/youtube-view",
                vClass: "",
                vIcon: "mdi-youtube",
                src: "/images/landing/youtube.png",
                vTitle: "Buff view youtube",
                vToJson: { name: 'youtube.view'},
            },
            {
                type: "list",
                vTo: "/youtube-sub",
                vClass: "",
                vIcon: "mdi-youtube",
                src: "/images/landing/youtube.png",
                vTitle: "Buff sub youtube",
                vToJson: { name: 'youtube.sub'},
            },
            {
                type: "list",
                vTo: "/youtube-like",
                vClass: "",
                vIcon: "mdi-youtube",
                src: "/images/landing/youtube.png",
                vTitle: "Buff like youtube",
                vToJson: { name: 'youtube.like'},
            },
            {
                type: "list",
                vTo: "/youtube-4k-view",
                vClass: "",
                vIcon: "mdi-youtube",
                src: "/images/landing/youtube.png",
                vTitle: "Buff 4k giờ xem",
                vToJson: { name: 'youtube.4k.view'},
            },
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-telegram",
        vIcon: "mdi-home",
        vTitle: "Telegram Buff",
        vClass: "menu-telegram-buff",
        child: [
            {
                type: "list",
                vTo: "/telegram",
                vClass: "",
                vIcon: "mdi-telegram",
                src: "/images/landing/telegram.png",
                vTitle: "Kéo member group",
                vToJson: { name: 'telegram.view'},
            },
        ]
    },
    {
        type: "group",
        prependIcon: "mdi-chart-bubble",
        vIcon: "mdi-home",
        vTitle: "Extension hay",
        vClass: "menu-extension",
        child: [
            {
                type: "list",
                vTo: "/extensions/filter-friend",
                vClass: "",
                vIcon: "mdi-account-search",
                vTitle: "Lọc bạn bè facebook",
                vToJson: { name: 'extension.filter-fb-friends'},
            },
            {
                type: "list",
                vTo: "/extensions/poke-friend",
                vClass: "",
                vIcon: "mdi-hand-pointing-right",
                vTitle: "Chọc bạn bè",
                vToJson: { name: 'extension.poke-fb-friends'},
            },
            {
                type: "list",
                vTo: "/extensions/get-cookie-and-access-token",
                vClass: "",
                vIcon: "mdi-cookie",
                vTitle: "Lấy Cookie và Access Token",
                vToJson: { name: 'extension.get-cookie-and-access-token'},
            },
        ]
    },

];
